module.exports = __webpack_public_path__ + "static/media/pu.29b28c72.png";